var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBench(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#13100D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.6,
    y1: 10.4,
    x2: 2.6,
    y2: 12.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.4,
    y1: 10.4,
    x2: 14.4,
    y2: 12.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.3,5.8v3 M14.3,5.8v3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.3,4.3h13c0.3,0,0.5,0.2,0.5,0.5v1c0,0.3-0.2,0.5-0.5,0.5h-13C2,6.3,1.8,6,1.8,5.8v-1C1.8,4.5,2,4.3,2.3,4.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,8.3h12.9c0.3,0,0.6,0.3,0.5,0.7l-0.3,1c-0.1,0.2-0.3,0.3-0.5,0.3H1.7c-0.3,0-0.6-0.3-0.5-0.7l0.3-1 C1.6,8.4,1.8,8.3,2,8.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBench);
export default __webpack_public_path__ + "static/media/bench.35be993089970e530c10faaf8dcf119b.svg";
export { ForwardRef as ReactComponent };